import React, { useEffect, useState } from "react";
import { ExerciseStationVideo, ExerciseTask } from "../../../types/exercise.type";
import "./Videos.css";
import { Video } from ".";

type VideosProps = {
	exerciseStationVideos?: ExerciseStationVideo[];
	showStations?: boolean;
	isPersonalTrainerLayout?: boolean;
	isGroupRoutine?: boolean;
	taskType?: ExerciseTask['type'];
	hidden?: boolean;
};

const Videos: React.FC<VideosProps> = ({ hidden = false, exerciseStationVideos = [], showStations = false, isPersonalTrainerLayout = false, isGroupRoutine = false, taskType }) => {

	const [applyOverlay, setApplyOverlay] = useState(false);

	const isSmallLayout = exerciseStationVideos.length <= 4 || isGroupRoutine;
	let overlayClass = `routine-${taskType}-overlay`;

	useEffect(() => {
		if (exerciseStationVideos.length > 6) {
			setApplyOverlay(true);
		} else {
			setApplyOverlay(false);
		}
	}, [exerciseStationVideos]);

	// Remove useMemo and directly render the mapped elements
	const renderedVideos = exerciseStationVideos.map((exercise) => {
		const containerClass = isPersonalTrainerLayout ? "pt-container" : isSmallLayout ? "small-container" : "large-container";
		const contentClass = isPersonalTrainerLayout ? "pt-content" : isSmallLayout ? "small-content" : "content-2";
		const textClass = isPersonalTrainerLayout ? "pt-text" : isSmallLayout ? "small-text" : "text-5";
		const exerciseTypeIcon = exercise.type == 1 ? '/img/strength.svg' : exercise.type == 2 ? '/img/cardio.svg' : undefined;

		return (
			<div className={`video-container ${containerClass} ${isGroupRoutine ? "is-group-routine" : ""} ${overlayClass}`} key={exercise.id}>
				<div className={contentClass}>
					{showStations && isSmallLayout && isPersonalTrainerLayout && (
						<div className="workout-movement pt-text">
							<div className="text">{exercise.station_number}</div>
							{exerciseTypeIcon &&
								<img className="exercise_type" alt="Exercise Type Icon" src={exerciseTypeIcon} />
							}

						</div>

					)}
					{showStations && isSmallLayout && !isPersonalTrainerLayout && (
						<div className="workout-movement small-text">
							<div className="text">{exercise.station_number}</div>
							{exerciseTypeIcon &&
								<img className="exercise_type" alt="Exercise Type Icon" src={exerciseTypeIcon} />
							}

						</div>
					)}
					<div className="workout">
						<div className={`video video-${exerciseStationVideos.length}`}>
							<Video url={exercise.video} key={exercise.id} />
						</div>
					</div>
					{showStations && !isSmallLayout && (
						<div className={`workout-movement ${applyOverlay ? 'apply-overlay' : ''}`}>
							<div className={textClass}>{exercise.station_number}</div>
							{exerciseTypeIcon &&
								<img className="exercise_type" alt="Exercise Type Icon" src={exerciseTypeIcon} />
							}
						</div>
					)}
				</div>
			</div>
		);
	});

	return (
		<div style={{ display: hidden ? 'none' : 'block' }}
			className={`videos ${isPersonalTrainerLayout && isSmallLayout ? "pt-layout" : isSmallLayout ? "small-layout" : "large-layout"}	${isGroupRoutine ? "is-group-routine" : ""}`}>
			{renderedVideos}
		</div>
	);
};

export default Videos;
